import { render, staticRenderFns } from "./NewSurveyForm.vue?vue&type=template&id=74b0752a&scoped=true&"
import script from "./NewSurveyForm.vue?vue&type=script&lang=ts&"
export * from "./NewSurveyForm.vue?vue&type=script&lang=ts&"
import style0 from "./NewSurveyForm.vue?vue&type=style&index=0&id=74b0752a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b0752a",
  null
  
)

export default component.exports